var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff583e",
    r: 256
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-3.109-.056-6.206-.166-9.288l-104.841-104.842-32.968-4.978-76.893-76.892-82.264 45.611 25.269 25.269-50.409 39.093-49.051 234.082 107.839 107.839c2.486.071 4.982.107 7.485.107 141.384-.001 255.999-114.616 255.999-256.001z",
    fill: "#db0404"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m125.981 117.208h48v83.318h-48z",
    fill: "#414952",
    transform: "matrix(.773 -.634 .634 .773 -66.728 131.115)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m320.36 134.867h83.318v48h-83.318z",
    fill: "#23272b",
    transform: "matrix(.634 -.773 .773 .634 9.627 338.077)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m232 77h48v74.728h-48z",
    fill: "#414952"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.644 77h24.356v74.728h-24.356z",
    fill: "#23272b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 289.326,
    fill: "#636978",
    rx: 162.674,
    ry: 162.674,
    transform: "matrix(.707 -.707 .707 .707 -129.604 265.761)"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 126.653c-.119 0-.237.004-.356.005v325.338c.119 0 .237.005.356.005 89.842 0 162.674-72.831 162.674-162.674s-72.832-162.674-162.674-162.674z",
    fill: "#414952"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 289.326,
    fill: "#fff",
    rx: 124.692,
    ry: 124.692,
    transform: "matrix(.707 -.707 .707 .707 -129.604 265.761)"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 164.634c-.119 0-.237.004-.356.005v249.375c.119 0 .237.005.356.005 68.866 0 124.692-55.827 124.692-124.692s-55.826-124.693-124.692-124.693z",
    fill: "#e9edf5"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.618 289.326h-30c0-53.145 43.237-96.382 96.382-96.382 27.601 0 53.924 11.866 72.221 32.555l-22.473 19.874c-12.605-14.253-30.738-22.429-49.748-22.429-36.604 0-66.382 29.779-66.382 66.382z",
    fill: "#7584f2"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 192.944c-.119 0-.237.004-.356.005v30.005c.119-.001.237-.009.356-.009 19.01 0 37.143 8.175 49.748 22.43l22.473-19.874c-18.297-20.691-44.62-32.557-72.221-32.557z",
    fill: "#606aea"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m224.618 251.078h128.629v30h-128.629z",
    fill: "#636978",
    transform: "matrix(.717 -.697 .697 .717 -103.704 276.849)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m324.57 210.478-68.926 67.059v41.856l89.846-87.412z",
    fill: "#414952"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m214.868 60h82.264v45.611h-82.264z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m255.644 60h41.488v45.611h-41.488z",
    fill: "#e9edf5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchIcon);
export default __webpack_public_path__ + "static/media/stopwatch-icon.aab8a63e69e66e1c6a03667fcb61e146.svg";
export { ForwardRef as ReactComponent };